import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/Guards/AuthGuard';
import { CargoClosureComponent } from './closure/cargo-closure.component';
import { PickingProductComponent } from './picking/picking-product.component';
import { ExitOrderComponent } from './exit-order/exit-order.component';
import { PreMerchandiseComponent } from './pre-merchandise/pre-merchandise.component';
import { ReceiptMerchandiseComponent } from './receipt-merchandise/receipt-merchandise.component';

const routes: Routes = [
    { path: 'cargo-closure', component: CargoClosureComponent, canActivate: [AuthGuard] },
    { path: 'picking-product', component: PickingProductComponent, canActivate: [AuthGuard] },
    { path: 'exit-order', component: ExitOrderComponent, canActivate: [AuthGuard] },
    { path: 'pre-merchandise', component: PreMerchandiseComponent, canActivate: [AuthGuard] },
    { path: 'receipt-merchandise', component: ReceiptMerchandiseComponent, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class WarehouseRoutingModule {

}
